import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

firebase.initializeApp({
  apiKey: 'AIzaSyBVI2ZY1RNUCxS7-TVrHqv2lJk8LPQIIEU',
  authDomain: 'handoff-web.firebaseapp.com',
  projectId: 'handoff-web',
  storageBucket: 'handoff-web.appspot.com',
  messagingSenderId: '180531645253',
  appId: '1:180531645253:web:6beea6c7076e8029334c2c',
  measurementId: 'G-NZXBR1GHKE'
});

// Export the authentication and firestore instances
export const auth = firebase.auth();
export const storage = firebase.storage().ref();
export const db = firebase.firestore();
